export default "__VITE_ASSET__ChlkDN21__"